var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.145,
    height: 29.729,
    viewBox: "0 0 23.145 29.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M395.3-85.44h-23.117c-.021.021 0 3.3 0 3.3v26.429l11.561-4.955 11.556 4.955V-82.14s.035-3.229 0-3.3zm-7.9 11.076h-3.977v2.027h3.677v2.237h-3.674v4.4h-2.455v-10.917h6.429z",
    transform: "translate(-372.174 85.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/F.babdc8995ca7a14a4c48963fb0383094.svg";
export { ForwardRef as ReactComponent };